import { render } from "./TransformItem.vue?vue&type=template&id=16a1a17b"
import script from "./TransformItem.vue?vue&type=script&lang=js"
export * from "./TransformItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__